
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class DeliveryChallanLaborGrid extends Serenity.EntityGrid<DeliveryChallanLaborRow, any> {
        protected getColumnsKey() { return 'Sales.DeliveryChallanLabor'; }
        protected getIdProperty() { return DeliveryChallanLaborRow.idProperty; }
        protected getInsertPermission() { return DeliveryChallanLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return DeliveryChallanLaborRow.localTextPrefix; }
        protected getService() { return DeliveryChallanLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}